import React from "react";
import { Toaster } from "react-hot-toast";
import Navigation from "./Navigation";

interface Props {
  children: React.ReactNode;
  userEmail: string;
  displayName?: string;
  onLogout?: () => void;
}

export default function Layout({ children, userEmail, displayName, onLogout }: Props) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <Navigation 
        userEmail={userEmail} 
        displayName={displayName} 
        onLogout={onLogout} 
      />
      
      <main className="flex-1">
        {children}
      </main>

      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0f172a",
            color: "#e2e8f0",
            border: "1px solid #334155"
          },
          success: {
            iconTheme: {
              primary: "#10b981",
              secondary: "#0f172a"
            }
          },
          error: {
            iconTheme: {
              primary: "#ef4444",
              secondary: "#0f172a"
            }
          }
        }}
      />

      {/* Footer */}
      <footer className="border-t border-slate-700/50 bg-slate-800/30 backdrop-blur-sm bottom-0">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-emerald-500/20 to-blue-500/20 border border-emerald-500/30 flex items-center justify-center">
                <span className="text-lg">🍽️</span>
              </div>
              <div className="text-slate-400">
                <div className="font-medium">Lunch Buddy</div>
                <div className="text-sm">Quản lý ăn trưa thông minh</div>
              </div>
            </div>
            
            <div className="flex items-center gap-6 text-slate-400 text-sm">
              <span>© 2025 Lunch Buddy</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

